<template>
    <v-card class="mx-auto">
        <v-row class="mb-2">
            <v-col xl="6" lg="12" md="6" sm="12">
                <v-date-picker :min="minDate" :max="maxDate" :show-current="GetArrival()" flat multiple v-model="dates">
                </v-date-picker>
            </v-col>
            <v-col xl="6" lg="12" md="6" sm="12">
                <v-col class="mb-0 pb-0 font-weight-black text-subtitle-2">
                    {{ Option.name }}
                </v-col>
                <v-col>
                    <v-img height="125" contain :src="Option.urlImage"></v-img>
                </v-col>
                <v-col class="py-0 text-decoration-underline">
                    Price:
                </v-col>
                <v-col class="py-0" v-if="Option.bookingExtraType !== 'PerPerson'">
                    {{ Option.displayPrice }}
                </v-col>
                <v-col class="py-0" v-if="Option.bookingExtraType === 'PerPerson'">
                    {{ Option.displayAdultAmount }} Per Adult and {{ Option.displayChildAmount }} Per Child
                </v-col>
                <v-col class="py-0 text-decoration-underline">
                    Description:
                </v-col>
                <v-col class="py-0">
                    {{ Option.description }}
                </v-col>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-card-actions class="mt-2">

            <v-col cols="5" sm="4" v-if="Option.bookingExtraType !== 'PerPerson'">
                Number of {{ getDescription }} <template v-if="Option.bookingExtraType === 'PerQuantity'">per
                    day</template> <br />
                <v-text-field type="number" v-model="pax" min="0" max="15" @input="validate" :readonly="isPerNight">
                    <v-icon slot="append" color="green" @click="add" v-if="!isPerNight" :disabled="isPerNight">
                        mdi-plus
                    </v-icon>
                    <v-icon slot="prepend" color="red" @click="minus" v-if="!isPerNight" :disabled="isPerNight">
                        mdi-minus
                    </v-icon>
                </v-text-field>
            </v-col>

            <v-col cols="5" sm="4" v-if="Option.bookingExtraType === 'PerPerson'">
                Number of Adult<br />
                <v-text-field type="number" v-model="paxAdult" min="0" max="15" @input="validate">
                    <v-icon slot="append" color="green" @click="addAddult">
                        mdi-plus
                    </v-icon>
                    <v-icon slot="prepend" color="red" @click="minusAddult">
                        mdi-minus
                    </v-icon>
                </v-text-field>
            </v-col>
            <v-col cols="2">

            </v-col>

            <v-col cols="5" sm="4" v-if="Option.bookingExtraType === 'PerPerson'">
                Number of Child<br />
                <v-text-field type="number" v-model="paxChild" min="0" max="15" @input="validate">
                    <v-icon slot="append" color="green" @click="addChild">
                        mdi-plus
                    </v-icon>
                    <v-icon slot="prepend" color="red" @click="minusChild">
                        mdi-minus
                    </v-icon>
                </v-text-field>
            </v-col>
        </v-card-actions>
    </v-card>
</template>


<script>

import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
    props: {
        Option: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            pax: 0,
            menu: false,
            dates: [],
            paxAdult: 0,
            paxChild: 0,
        }
    },
    methods: {
        add: function () {
            if (this.pax < 15)
                this.pax++;

            let total = this.pax * this.dates.length;

            console.log(total, 'totaladd');

            if (total <= -1 && total === undefined)
                return


            let model = {
                ...this.Option,
                amount: this.Option.amount * total,
                description: `${this.dates.join()}`,
                tempDescription: '-',
                isMandatory: false,
                addOnType: 'PerQuantity',
                showOptional: true

            }

            this.$emit('addChargeSelection', model, total)
        },
        minus: function () {
            if (this.pax > 0)
                this.pax--;

            let total = this.pax * this.dates.length;


            if (total <= -1 && total === undefined)
                return

            let model = {
                ...this.Option,
                amount: this.Option.amount * total,
                description: `${this.dates.join()}`,
                tempDescription: '-',
                isMandatory: false,
                addOnType: 'PerQuantity',
                showOptional: true

            }


            this.$emit('addChargeSelection', model, total)
        },
        addAddult: function () {
            if (this.paxAdult < 15)
                this.paxAdult++;

            let total = this.paxAdult * this.dates.length;

            if (total <= -1 && total === undefined)
                return

            let model = {
                ...this.Option,
                amount: this.Option.adultAmount * total,
                displayPrice: this.Option.displayAdultAmount,
                name: `${this.Option.name}-Adult`,
                tempDescription: 'Adult',
                description: `${this.dates.join()}`,
                isMandatory: false,
                addOnType: 'Adult',
                showOptional: true
            }
            this.$emit('addChargeSelection', model, total)
        },
        minusAddult: function () {
            if (this.paxAdult > 0)
                this.paxAdult--;

            let total = this.paxAdult * this.dates.length;

            if (total <= -1 && total === undefined)
                return

            let model = {
                ...this.Option,
                amount: this.Option.adultAmount * total,
                displayPrice: this.Option.displayAdultAmount,
                name: `${this.Option.name}-Adult`,
                tempDescription: 'Adult',
                description: `${this.dates.join()}`,
                isMandatory: false,
                addOnType: 'Adult',
                showOptional: true
            }
            this.$emit('addChargeSelection', model, total)
        },
        addChild: function () {
            if (this.paxChild < 15)
                this.paxChild++;

            let total = this.paxChild * this.dates.length;

            if (total <= -1 && total === undefined)
                return

            let model = {
                ...this.Option,
                amount: this.Option.childAmount * total,
                displayPrice: this.Option.displayAdultAmount,
                name: `${this.Option.name}-Child`,
                tempDescription: 'Child',
                description: `${this.dates.join()}`,
                isMandatory: false,
                addOnType: 'Child',
                showOptional: true
            }
            this.$emit('addChargeSelection', model, total)
        },
        minusChild: function () {
            if (this.paxChild > 0)
                this.paxChild--;

            let total = this.paxChild * this.dates.length;

            if (total <= -1 && total === undefined)
                return

            let model = {
                ...this.Option,
                amount: this.Option.childAmount * total,
                displayPrice: this.Option.displayChildAmount,
                name: `${this.Option.name}-Child`,
                tempDescription: 'Child',
                description: `${this.dates.join()}`,
                isMandatory: false,
                addOnType: 'Child',
                showOptional: true

            }
            this.$emit('addChargeSelection', model, total)
        },
        validate() {
            // console.log(this.pax);
            // this.$emit('addChargeSelection', this.Option, this.pax)
        },
        onChangeDates: function () {
            if (this.Option.bookingExtraType === 'PerPerson') {
                //FOR CHILD
                let total = this.paxChild * this.dates.length;

                if (total <= -1 && total === undefined)
                    return

                let modelChild = {
                    ...this.Option,
                    amount: this.Option.childAmount * total,
                    displayPrice: this.Option.displayChildAmount,
                    name: `${this.Option.name}-Child`,
                    tempDescription: 'Child',
                    description: `${this.dates.join()}`,
                    isMandatory: false,
                    addOnType: 'Child',
                    showOptional: true

                }
                this.$emit('addChargeSelection', modelChild, total)


                //FOR ADULT
                let totalAdult = this.paxAdult * this.dates.length;

                if (totalAdult <= -1 && totalAdult === undefined)
                    return

                let model = {
                    ...this.Option,
                    amount: this.Option.adultAmount * totalAdult,
                    displayPrice: this.Option.displayAdultAmount,
                    name: `${this.Option.name}-Adult`,
                    tempDescription: 'Adult',
                    description: `${this.dates.join()}`,
                    isMandatory: false,
                    addOnType: 'Adult',
                    showOptional: true
                }
                this.$emit('addChargeSelection', model, totalAdult)

            } else if (this.Option.bookingExtraType !== 'PerPerson') {
                let total = this.pax * this.dates.length;
                let isMandatory = false;
                if (this.Option.bookingExtraType === 'PerNight') {
                    total = this.dates.length;
                    this.pax = total;
                    
                    isMandatory = false;
                }



                if (total <= -1 && total === undefined)
                    return


                let model = {
                    ...this.Option,
                    amount: this.Option.amount * total,
                    description: `${this.dates.join()}`,
                    isMandatory: isMandatory,
                    addOnType: 'PerQuantity',
                    showOptional: true

                }


                this.$emit('addChargeSelection', model, total)
            }
        }
    },
    computed: {
        getDescription: function () {
            let ex = this.Option.bookingExtraType;
            let description = "";
            switch (ex) {
                case "PerBooking":
                    description = "Per Booking";
                    break;
                case "PerQuantity":
                    description = this.Option.name;
                    break;
                case "PerPerson":
                    description = "";
                    break;
                case "PerNight":
                    description = "Night(s)";
                    break;
            }

            return description;

        },
        isPerNight: function () {
            return this.Option.bookingExtraType === 'PerNight'
        },
        ...mapGetters(['GetArrival',
            'GetDeparture',]),
        maxDate: function () {
            let departureDate = moment(this.GetDeparture()).format('YYYY-MM-DD');

            if (this.Option.offerEndDate === "") {
                return departureDate;
            }

            let offerEndDate = moment(this.Option.offerEndDate).format('YYYY-MM-DD');

            if (departureDate < offerEndDate) {
                return departureDate;
            } else {
                return offerEndDate;
            }

        },
        minDate: function () {

            let arrivalDate = moment(this.GetArrival()).format('YYYY-MM-DD');
            if (this.Option.offerStartDate === "") {
                return arrivalDate;
            }

            let offerStartDate = moment(this.Option.offerStartDate).format('YYYY-MM-DD');

            if (arrivalDate < offerStartDate) {
                return offerStartDate;
            } else {
                return arrivalDate;
            }
        }
    },
    watch: {
        dates: function () {
            this.onChangeDates();
        }
    }
}

</script>

<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>